export class ApiError extends Error {
  constructor(message, statusCode) {
    super(message); // (1)
    this.name = 'ApiError'; // (2)
    this.statusCode = statusCode;
  }
}
